import { render, staticRenderFns } from "./Pace.vue?vue&type=template&id=dbe63bb4&scoped=true&"
import script from "./Pace.vue?vue&type=script&lang=ts&"
export * from "./Pace.vue?vue&type=script&lang=ts&"
import style0 from "./Pace.vue?vue&type=style&index=0&id=dbe63bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe63bb4",
  null
  
)

export default component.exports